import {MODES} from './../Constants/Modes';

export const executeLimitProfileAddAction = parent => {
    parent.props.history.push({
        pathname: '/limitProfile/addLimitProfile',
        state: {mode: MODES.ADD},
    });
};
